import React, { Fragment, useState, useEffect } from 'react';

const CallsAnalysis = (props) => {
    let { rowdata, nameLabelMapper, lablename } = props;
    const [callAnalysis, setCallAnalysis] = useState({});

    useEffect(() => {
        try {
            let jsonData = rowdata?.[nameLabelMapper?.["Call_Analysis"]];
            if (jsonData !== 'null'  && jsonData !==  null && jsonData !== undefined && jsonData !== "")  {
                let data = JSON.parse(jsonData);
                setCallAnalysis(data);
            } else {
                setCallAnalysis({});
            }
        } catch (error) {
            console.error("Error parsing Call_Analysis JSON:", error);
            setCallAnalysis({});
        }
    }, [rowdata,nameLabelMapper]);

    return (
        <Fragment>
            <div className='call-summary-container'> 
                <div>
                    <span className='call-summary-label'>{lablename}</span>
                </div>
                
                {Object.keys(callAnalysis).length > 0 ? (
                <div >
                    <ul>
                        {Object.entries(callAnalysis).map(([key, value]) => (
                            <li>
                            <li key={key} className='kv-row'>
                                <strong className='kv-key me-2'>{key} </strong> <span className='kv-value ms-5'>{value}</span>
                            </li>
                            </li>
                        ))}
                    </ul>
                </div>
                ) : (
                    <div className='call-summary-content'>No Extracted Info Found</div>
                )}
            </div>
        </Fragment>
    );
};

export default CallsAnalysis;
